import React from 'react'
import { t } from 'ttag'

import { Form } from 'components/shared/Form/Form'

import { NON_FIELD_ERRORS, getApiError } from 'utils/apiErrors'
import { TEMPLATE_NAME_FIELD } from './model'
import { TEMPLATE_NAME_FIELD_LIMIT } from './../../schema'

import styles from './CreateTemplate.module.scss'

export const CreateTemplate = ({ control, formState, watch }) => (
  <div className={styles.create}>
    <Form>
      <Form.Field
        count={watch(TEMPLATE_NAME_FIELD)?.length}
        error={
          getApiError(formState.errors?.root?.apiError, NON_FIELD_ERRORS) ??
          formState.errors[TEMPLATE_NAME_FIELD]?.message
        }
        field="input"
        hint={t`Name needs to be unique.`}
        limit={TEMPLATE_NAME_FIELD_LIMIT}
        label={t`Add template name`}
        name={TEMPLATE_NAME_FIELD}
        placeholder={t`Add template name...`}
        {...{ control }}
      />
    </Form>
    <p className={styles.text}>
      {t`When you create a template, it is added to`}{' '}
      <span className={styles.templates}>{t`Templates`}.</span>{' '}
      {t`If you are unsure about the name of the new template, you will be able to edit or save job as template later.`}
    </p>
  </div>
)
